import logo from '@/assets/Nav_Logo.svg';
import { DesktopMenu } from './DesktopMenu';

export const LeftNav = () => {
  return (
    <div className="flex items-center justify-between gap-2 lg:gap-8 h-full">
      <img src={logo} alt="logo" className="max-w-20" />
      <DesktopMenu />
    </div>
  );
};
